import Vue from 'vue'

import VueI18n from 'vue-i18n' // 引入国际化的包

import elementEN from 'element-ui/lib/locale/lang/en' // 引入饿了么的英文包

import elementZH from 'element-ui/lib/locale/lang/zh-CN' // 引入饿了么的中文包

import en from "./en.js"

import zh from "./zh.js"

Vue.use(VueI18n) // 全局注册国际化包

export default new VueI18n({
  locale: localStorage.getItem('language') || 'en', // 

  messages: {
    en: {
      ...en, // 将en.js语言包引入

      ...elementEN, // 将饿了么的英文语言包引入

    },

    zh: {
      ...zh, // 加载zh.js语言包引入

      ...elementZH, // 将饿了么的中文语言包引入

    },

  }

})
